import ReactDOM from 'react-dom/client';
import { useEffect, useState, useRef } from "react";

const SearchPlayers = () => {

    const [players, setPlayers] = useState([])

    const [search, setSearch] = useState('')

    const [show, setShow] = useState('')

    const inputRef = useRef(null)

    const handleKeyPress = (event) => {
        
        if (event.key === 'Enter') {
            const findPlayer = players?.
                filter(
                    x =>
                        x.SportsCode === _shared_values.Selected_Sports.toUpperCase() && x.Label.toLowerCase().includes(search.toLowerCase())
                ).slice(0, 1)
            const firstData = Object.values(findPlayer)[0];
            if (firstData) {
                const { Id, SportsCode, PlayerOrTeam } = firstData;
                selectedPlayer(Id, SportsCode, PlayerOrTeam);
            }


        }
    };

    const handleSearchOnChanged = e => {
        
        setSearch(e.target.value)
        setShow(e.target.value?.trim() !== '' ? 'show' : '')
    }

    const filterPlayers = () => {
        return players?.filter((player) => {
            const searchWords = search.toLowerCase().split(' ');
            const playerName = player.Label.toLowerCase();
            const sc = player.SportsCode.toUpperCase();
            const selectedSports = _shared_values.Selected_Sports.toUpperCase();
            // Check if any of the search words are present in the player's first name, last name,
            // and if the SportsCode matches a selected sport
            return searchWords.every((word) => playerName.includes(word) && selectedSports.includes(sc));
        }).slice(0, 10);


    };


    const selectedPlayer = (id, sportsCode, playerOrTeam) => {

        clearSearch()

        if (playerOrTeam === "PLAYER")
            window.open(`/${sportsCode}/player/${id}`, "_self")
        else
            if (sportsCode === "NFL" || sportsCode === "MLB")
                window.open(`/${sportsCode}/Team?Id=${id}`, "_self")
    }

    const handleClickOutside = e =>
        !e.target.closest("div.card-body")?.classList.contains("searchRefClass") && !e.target.classList.contains("main-player-search") && clearSearch()

    const clearSearch = () => {
        setShow('')
        setSearch('')
    }

    useEffect(() => {

        fetch('/Home/GetAllPlayers')
            .then(response => {
                return response.json()
            })
            .then(data => {                
                setPlayers(data)

            });

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);

    }, [])

    return (

        <div className="input-group resp_parent">

            <span className="input-group-text bg-white"
                id="inputGroup-sizing-sm">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search text-secondary" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                </svg>
            </span>

            <input
                onKeyDown={(e) => handleKeyPress(e)}
                onChange={(e) => { handleSearchOnChanged(e) }}
                value={search}
                ref={inputRef}
                className="text-secondary main-player-search px-2"
                type="text" placeholder="Search Players or Teams" aria-label="Search"
                style={{ color: 'dimgray !important', border: '1px solid #ced4da', width: "350px", "height": "38px" }}
                data-bs-toggle={`${show === "show" ? "dropdown" : ""}`}
            />
            <div
                className={`dropdown-menu p-0 ` + show}

                style={{ position: 'absolute', inset: '0px auto auto 0px; margin: 0px', transform: 'translate(0px, 38px)', width: '100%' }} data-popper-placement="bottom-start">
                {
                    search.trim() !== '' &&
                    filterPlayers()
                        .map((p, idx) => {
                            return (

                                <div
                                    onClick={() => selectedPlayer(p.Id, p.SportsCode, p.PlayerOrTeam)}
                                    key={p.Id + '_' + idx}
                                    className="card text-start border-0 mt-2"
                                    data-label={p.Label}
                                    data-value={p.Id}
                                >
                                    <div
                                        className="card-body p-0 searchRefClass">
                                        <div className="text-start d-inline">
                                            <button
                                                type="button"
                                                className="dropdown-item"
                                            >

                                                <span className="badge fw-normal mx-1 text-start">
                                                    {
                                                        p.PlayerOrTeam === 'TEAM'
                                                            ?
                                                            <>
                                                                <span className="card-title fs-6 text-dark">
                                                                    {p.Label}
                                                                </span>
                                                            </>
                                                            :
                                                            <>
                                                                <span className="card-title fs-6 text-dark">
                                                                    {p.Label} {p.Position}
                                                                </span>
                                                                <span className="card-title fs-6 d-block mt-1" style={{ color: "#7D7D7D" }}>
                                                                    {p.Label2}
                                                                </span>
                                                            </>
                                                    }

                                                </span>

                                            </button>
                                        </div>
                                    </div>
                                </div>

                            )
                        })
                }

            </div>

        </div>

    );

}

const root = ReactDOM.createRoot(document.getElementById('search-players-react'));
root.render(
    <SearchPlayers />
);